import http from "../../http";

const operator = {

    selectByOrgCode(r) {
        return http.get("/gateway/api/sycompany/pc/operator/selectByOrgCode", r)
    },



}
export default operator
